import { render, staticRenderFns } from "./CreditsDisplay.vue?vue&type=template&id=2c14b030&scoped=true&"
import script from "./CreditsDisplay.vue?vue&type=script&lang=js&"
export * from "./CreditsDisplay.vue?vue&type=script&lang=js&"
import style0 from "./CreditsDisplay.vue?vue&type=style&index=0&id=2c14b030&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c14b030",
  null
  
)

export default component.exports